<template>
    <div>
        <validation-observer
                ref="observer"
        >
        <v-row>

            <v-col cols="12">
                <validation-provider
                        v-slot="{ errors }"
                        name="Training Class"
                        rules="required"
                >
                    <ClassSearch
                            v-model="trainingClass"
                            :error-messages="errors"
                    />
                </validation-provider>
            </v-col>
            <v-col cols="6">
                <v-text-field
                        v-model="firstName"
                        label="First Name"
                />
            </v-col>
            <v-col cols="6">
                <validation-provider
                        v-slot="{ errors }"
                        name="Last Name"
                        rules="required"
                >
                    <v-text-field
                            v-model="lastName"
                            label="Last Name *"
                            :error-messages="errors"
                    />
                </validation-provider>
            </v-col>
            <v-col cols="12">
                <validation-provider
                        v-slot="{ errors }"
                        name="Email"
                        rules="email"
                >
                    <v-text-field
                            v-model="email"
                            label="Email"
                            type="email"
                            :error-messages="errors"
                            required
                    />
                </validation-provider>

            </v-col>

            <v-col cols="12" class="d-flex">
                <v-spacer></v-spacer>

                <v-btn
                        color="green darken-1"
                        dark
                        @click="createAttendee"
                >
                    Create
                </v-btn>
            </v-col>
        </v-row>
        </validation-observer>
    </div>
</template>

<script>

    import ClassSearch from "../../AutoCompletes/ClassSearch";
    import ATTENDEE_CREATE from "../../../graphql/Attendee/Create.gql";
    import {required} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        components: {
            ClassSearch,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            booking: {
                type: Object,
            },
        },
        data() {
            return {
                trainingClass: null,
                firstName: null,
                lastName: 'TBA',
                email: null,
            }
        },
        methods: {
            createAttendee() {
                this.$refs.observer.validate().then((valid) => {
                    if(!valid) return

                    this.updating = true
                    this.$apollo.mutate({
                        mutation: ATTENDEE_CREATE,
                        variables: {
                                input: {
                                    firstName: this.firstName,
                                    lastName: this.lastName,
                                    email: this.email,
                                    trainingClass: {connect: this.trainingClass},
                                    booking: {connect: this.booking.id},
                                }
                            },
                    }).then(() => {
                        this.$emit('complete')
                        this.updating = false
                        this.$store.dispatch('notification/addSuccess', 'Added attendee successfully')
                    }).catch((error) => {
                        this.updating = false
                        this.$store.dispatch('notification/handleGraphQlError', error)
                    })
                });

            },
            validate () {
                return this.$refs.observer.validate()
            },
        },
    }
</script>

<style scoped>

</style>